import { ColDef } from '@ag-grid-enterprise/all-modules';
import i18n from 'i18n';
import { warrantStateValueFormatter } from 'utils/valueFormatters';
import { dateFilterParams } from '../../../shared/constants/index';

export const warrantGridStateColumnFilters = [
  'ACTIVE',
  'EXPIRED',
  'PAUSED',
  'PENDING',
  'STOPPED',
];

export const warrantGridStateColumnTrashedFilters = ['TRASHED'];

const WarrantGridColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('warrant.grid.state'),
    field: 'state',
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    sortable: false,
    tooltipField: 'state',
    filterParams: {
      values: warrantGridStateColumnFilters
    },
    cellRenderer: 'warrantStateCellRenderer'
  },
  {
    headerName: i18n.t('warrant.grid.warrantName'),
    field: 'name',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    tooltipField: 'name'
  },
  {
    headerName: i18n.t('warrant.grid.startTime'),
    field: 'startDateTime',
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    tooltipField: 'startDateTime',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer'
  },
  {
    headerName: i18n.t('warrant.grid.stopTime'),
    field: 'stopDateTime',
    tooltipField: 'stopDateTime',
    floatingFilter: true,
    filter: 'agDateColumnFilter',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer'
  },
  {
    headerName: i18n.t('warrant.grid.contact'),
    field: 'contact.name',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    tooltipField: 'contact.name'
  },
  {
    headerName: i18n.t('warrant.grid.comments'),
    field: 'comments',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    tooltipField: 'comments'
  },
  {
    headerName: i18n.t('warrant.grid.judge'),
    field: 'judge',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    tooltipField: 'judge'
  },
  {
    headerName: i18n.t('warrant.grid.receivedTime'),
    field: 'receivedDateTime',
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    tooltipField: 'receivedDateTime',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer'
  },
  {
    headerName: i18n.t('warrant.grid.city'),
    field: 'city',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    tooltipField: 'city'
  },
  {
    headerName: i18n.t('warrant.grid.geographicalState'),
    field: 'province',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    tooltipField: 'province'
  },
  {
    headerName: i18n.t('warrant.grid.region'),
    field: 'region',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    tooltipField: 'region'
  },
  {
    headerName: i18n.t('warrant.grid.timeZone'),
    field: 'timeZone',
    sortable: false,
    tooltipField: 'timeZone',
    cellRenderer: 'TimeZoneCellRenderer',
    floatingFilter: true
  },
  {
    headerName: i18n.t('warrant.grid.numberAttachments'),
    field: 'num_of_attachments',
    filter: 'agNumberColumnFilter',
    tooltipField: 'num_of_attachments',
    floatingFilter: true
  }
];

export default WarrantGridColumnDefs;
